import script from "./titleText.vue?vue&type=script&setup=true&lang=js"
export * from "./titleText.vue?vue&type=script&setup=true&lang=js"

import "./titleText.vue?vue&type=style&index=0&id=f9772f16&lang=scss&scoped=true"

import exportComponent from "D:\\zwy\\sdt\\云服务器租赁\\node_modules\\_vue-loader@17.0.1@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9772f16"]])

export default __exports__